import { ReportsType } from '@features/reports/enums/reportsType'

export const REPORTS_ROUTE_LABEL_KEYS: Record<ReportsType, string> = {
  [ReportsType.ProfitAndLoss]: 'reports.profit_and_loss',
  [ReportsType.BalanceSheet]: 'reports.balance_sheet',
  [ReportsType.TrialBalance]: 'reports.trial_balance',
}

export const REPORTS_IDS: ReportsType[] = [
  ReportsType.ProfitAndLoss,
  ReportsType.BalanceSheet,
  ReportsType.TrialBalance,
]
